import { API_BASE_URL } from '../../config/api';

const CategoriesData = {
    fetch: async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/categoriasInf`);
            const data = await response.json();

            if (data.message === "No hay categorias registrados") {
                return data;
            }

            // If data is a single object, wrap it in an array
            const catArray = Array.isArray(data.categorias) ? data.categorias : [data.categorias];
            
            return catArray.map(cat => ({
                id: cat.catId,
                nombre: cat.catnombre?.trim(),
                emin: cat.edadMinima,
                emax: cat.edadMaxima,
                rama: cat.rama
            }));
        } catch (error) {
            console.error('Error fetching categorias:', error);
            return { message: "Error al cargar las categorias" };
        }
    },
};

export default CategoriesData;